var _defs, _path, _path2, _path3, _polyline, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _ellipse, _ellipse2, _ellipse3, _line, _ellipse4, _ellipse5, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _polygon9, _polygon10, _polygon11, _path10, _path11, _path12, _line2, _line3, _line4, _line5, _polyline2, _polyline3, _polyline4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 150.31,
    y1: 266.75,
    x2: 173.69,
    y2: 228.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#754c24"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.1,287.7,15.38,181.48c-5.72-3.21-10.63-8.49-5.05-11.94l180.37-104c2.71-1.68,6.82-2.78,9.57-1.18L388.93,173.89c5.72,3.32,6.75,12.6,1,15.93L218.8,287.53A23.9,23.9,0,0,1,195.1,287.7Z",
    fill: "#8b298e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M350.79,123.62c.64.39,0,25.09,0,25.09L250.14,91.49V66.32",
    fill: "none",
    stroke: "#6f4f64",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6,121.7c-.64.39,0,16.19,0,16.19L158.25,80.66V66.34",
    fill: "none",
    stroke: "#6f4f64",
    strokeMiterlimit: 10
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "97.59 148.72 204.41 216.46 312.14 154.57",
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "170.18 145.96 203.08 165.5 238.55 144.68 204.37 125.55 170.18 145.96",
    fill: "#68e1fd"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.55 144.68 238.55 220.11 204.37 239.79 203.08 165.5 238.55 144.68",
    fill: "#68e1fd"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "170.18 145.96 203.08 165.5 238.55 144.68 204.37 125.55 170.18 145.96",
    fill: "#606060",
    opacity: 0.11
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.55 144.68 238.55 220.11 204.37 239.79 203.08 165.5 238.55 144.68",
    fill: "#606060",
    opacity: 0.52
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "170.18 145.96 170.18 221.05 204.37 239.79 203.08 165.5 170.18 145.96",
    fill: "#68e1fd"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "327.35 116.48 327.35 77.08 375.21 105.27 375.21 145.16 327.35 116.48",
    fill: "#68e1fd"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "275.1 141.51 275.1 102.11 322.96 130.3 322.96 170.2 275.1 141.51",
    fill: "#ff9f9f"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "231.62 62.43 231.62 23.03 279.48 51.22 279.48 91.11 231.62 62.43",
    fill: "#e99a53"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 351.18,
    cy: 110.61,
    rx: 6.21,
    ry: 9.43,
    transform: "translate(-16.18 135.2) rotate(-21.31)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.57,
    cy: 50.21,
    rx: 6.21,
    ry: 9.43,
    transform: "translate(-1.52 92.33) rotate(-21.31)",
    fill: "#fff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.49,
    cy: 66.32,
    rx: 3.74,
    ry: 5.68,
    transform: "translate(-6.02 100.67) rotate(-21.31)",
    fill: "#fff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 283.92,
    y1: 114.87,
    x2: 310.42,
    y2: 153.63,
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.2,
    cy: 134.93,
    rx: 4.89,
    ry: 7.42,
    transform: "translate(-29.47 113.25) rotate(-21.31)",
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.42,
    cy: 139.08,
    rx: 4.89,
    ry: 7.42,
    transform: "translate(-29.32 122.34) rotate(-21.31)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.61,138.67c-1.64,0-5-4.16-6.14-5.39a28.32,28.32,0,0,1-4.64-7C177.2,112,186.08,92.7,202.6,91.56a30.59,30.59,0,0,1,3.51,0C217,92,225.23,102.84,226.22,113a30.22,30.22,0,0,1-2.62,15,22.71,22.71,0,0,1-4.11,6.07c-1.18,1.24-4.7,5.06-6.52,5Z",
    fill: "#fbb03b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.85,139.74l-2.1-28.67s-3.85-7-6.55-2.06,2.9,8.24,14.32,7.75,13.49-5.88,11-8-6.64.79-6.85,2.26-2.57,28.67-2.57,28.67",
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.78,135.46c-3.89,2.19-8.11,2.77-12.81,2.77s-10.08,0-14.3-2.36a1.44,1.44,0,0,0-.24.75v3.63a1.48,1.48,0,0,0,1.48,1.48h25a1.48,1.48,0,0,0,1.48-1.48v-3.63A1.46,1.46,0,0,0,217.78,135.46Z",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 190.43,
    y: 141.74,
    width: 27.95,
    height: 6.59,
    rx: 1.19,
    ry: 1.19,
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.91,148.33s1.28,4.77,12.49,4.59,14-6.07,14-6.07",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M217.18,139.36a29.24,29.24,0,0,1-25.76,1.44c-.73-.31-1.37.76-.63,1.08a30.55,30.55,0,0,0,27-1.44C218.51,140,217.89,139,217.18,139.36Z",
    fill: "#afa7a1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216.07,145.9a27.37,27.37,0,0,1-24,1c-.73-.32-1.36.76-.63,1.08a28.69,28.69,0,0,0,25.26-1C217.4,146.6,216.77,145.52,216.07,145.9Z",
    fill: "#afa7a1"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.3 112.89 75.3 73.5 27.44 101.68 27.44 141.58 75.3 112.89",
    fill: "#e99a53"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "127.55 130.76 127.55 91.36 79.68 119.55 79.68 159.44 127.55 130.76",
    fill: "#ff9f9f"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "171.03 58.85 171.03 19.45 123.17 47.63 123.17 87.53 171.03 58.85",
    fill: "#68e1fd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.17,71.07a24.09,24.09,0,0,1,6.47-11.33c2.25-2.12,5.07-4,8.3-3.39,3.7.67,4.47,4.48,7.71,5.54,5.77,1.89,8-7.68,8.8-11.45.9-4.23,3.21-12.29,8-14,8-2.94,8.59,8.42,8.59,8.42",
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.17,80.2a24.09,24.09,0,0,1,6.47-11.33c2.25-2.12,5.07-4,8.3-3.39,3.7.67,4.47,4.48,7.71,5.54,5.77,1.89,8-7.68,8.8-11.45.9-4.23,3.21-12.29,8-14C170.47,42.6,171,54,171,54",
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.17,61.59a24.09,24.09,0,0,1,6.47-11.33c2.25-2.12,5.07-4,8.3-3.39,3.7.67,4.47,4.48,7.71,5.54,5.77,1.89,8-7.68,8.8-11.45.9-4.23,3.21-12.29,8-14,8-2.94,8.59,8.42,8.59,8.42",
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 79.68,
    y1: 126.97,
    x2: 127.55,
    y2: 98.78,
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 79.68,
    y1: 135.35,
    x2: 127.55,
    y2: 107.16,
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 79.68,
    y1: 143.65,
    x2: 127.55,
    y2: 115.46,
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 79.68,
    y1: 152.03,
    x2: 127.55,
    y2: 123.84,
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "27.44 132.14 54.89 98.53 75.3 105.95",
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "27.44 141.15 54.89 107.54 75.3 114.95",
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "26.02 124.34 53.47 90.73 76.72 99.18",
    fill: "none",
    stroke: "#f2f2f2",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.18,221l-44.71,25.49,37,21.88,41.87-28.64C201.2,237.75,173.37,223,170.18,221Z",
    opacity: 0.63,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.fc188461255fa13c5edafa9c7bd2a984.svg";
export { ForwardRef as ReactComponent };